import type { Props } from "../../../types";
import { classNameParser } from "../../../helpers";

import "./style.css";

export const Checklist = (props: Props) => (
  <div className={classNameParser("flex space-x-[33px]", props.className)} style={props.style}>
    {props.children}
  </div>
);

export const ChecklistItem = (props: Props) => (
  <div className={classNameParser("flex", props.className)} style={props.style}>
    <div className="checklist--bullet" />
    {props.children}
  </div>
);
